// removed by extract-text-webpack-plugin
module.exports = {"Tab":"tabs__Tab__GI5U9","TabNotification":"tabs__TabNotification__142JD","bounce":"tabs__bounce__3Jit_","NewTab":"tabs__NewTab__hoZdU","TabBox":"tabs__TabBox__F-q6T","TabName":"tabs__TabName__1XaoX","Active":"tabs__Active__3p-LL"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/tabs.css
// module id = 1077
// module chunks = 2